import { DEFAULT_COUNTRY_CODE, type CountryCode } from '@/components/customer-address-form/constants';

const SITE_ID_TO_COUNTRY_CODES: Record<string, readonly CountryCode[]> = {
    EAT1: ['IT', 'VA', 'SM'],
    USEN: ['US'],
    DE01: ['DE'],
};

/**
 * Returns the ISO country codes allowed in address forms for the active commerce site.
 */
export function getCountryCodesForSite(siteId: string): readonly CountryCode[] {
    return SITE_ID_TO_COUNTRY_CODES[siteId] ?? [DEFAULT_COUNTRY_CODE];
}

/**
 * Returns the preferred/default country for the active commerce site.
 */
export function getCountryCodeForSite(siteId: string): CountryCode {
    return getCountryCodesForSite(siteId)[0];
}

/** Invoice billing on the Italian storefront is limited to Italy. */
export function getInvoiceCountryCodesForSite(siteId: string): readonly CountryCode[] {
    return siteId === 'EAT1' ? ['IT'] : getCountryCodesForSite(siteId);
}

export function isInvoiceShippingCountryAllowed(siteId: string, countryCode: string): boolean {
    return siteId !== 'EAT1' || countryCode === 'IT';
}
